<div class="menu" [class.menu--collapsed]="collapsed">
  <div class="menu__header">
    <img src="/assets/images/logo.svg" alt="Cash Pilot" class="logo">
    <div class="brand">
      <span class="brand__title">Cash</span>
      <span class="brand__subtitle">Pilot</span>
    </div>
  </div>

  <nav class="menu__nav" aria-label="Navigation principale">
    <div class="menu__organization-selector">
      <leaf-organization-selector [reduced]="collapsed" menuXPosition="after" menuYPosition="above" adminCompleteMode="always"></leaf-organization-selector>
    </div>

    <div class="menu__section">
      <span class="menu__section-label">{{ 'app.menu.sections.application' | translate }}</span>
      <a mat-button routerLink="/dashboard"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.dashboard' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>account_tree</mat-icon>
        <span>{{ 'app.menu.links.dashboard' | translate }}</span>
      </a>
      <a mat-button routerLink="/variables"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.variables' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>tune</mat-icon>
        <span>{{ 'app.menu.links.variables' | translate }}</span>
      </a>
      <a mat-button routerLink="/flux"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.flux' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>payments</mat-icon>
        <span>{{ 'app.menu.links.flux' | translate }}</span>
      </a>
      <a mat-button routerLink="/ventes"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.sales' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>storefront</mat-icon>
        <span>{{ 'app.menu.links.sales' | translate }}</span>
      </a>
      <a mat-button routerLink="/simulations"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.simulations' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>insights</mat-icon>
        <span>{{ 'app.menu.links.simulations' | translate }}</span>
      </a>
      <a mat-button routerLink="/comparaisons"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.comparisons' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>compare_arrows</mat-icon>
        <span>{{ 'app.menu.links.comparisons' | translate }}</span>
      </a>
      <a mat-button routerLink="/objectifs"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.objectives' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>flag</mat-icon>
        <span>{{ 'app.menu.links.objectives' | translate }}</span>
      </a>
      <a mat-button routerLink="/members-rights"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.membersRights' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>group</mat-icon>
        <span>{{ 'app.menu.links.membersRights' | translate }}</span>
      </a>
    </div>

    <div class="menu__section" *ngIf="isAdmin$ | async">
      <span class="menu__section-label">{{ 'app.menu.sections.configuration' | translate }}</span>
      <a mat-button routerLink="/admin/organizations"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.organizations' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>business</mat-icon>
        <span>{{ 'app.menu.links.organizations' | translate }}</span>
      </a>
      <a mat-button routerLink="/admin/workspace-settings"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.configuration' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>settings</mat-icon>
        <span>{{ 'app.menu.links.configuration' | translate }}</span>
      </a>
    </div>
  </nav>

  <div class="menu__footer">
    <a mat-button routerLink="/settings"
       routerLinkActive="active"
       class="navigation-link"
       [matTooltip]="collapsed ? ('app.menu.links.account' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>manage_accounts</mat-icon>
      <span>{{ 'app.menu.links.account' | translate }}</span>
    </a>

    <a mat-button class="navigation-link" (click)="toggleCollapse()"
       [matTooltip]="collapsed ? ('app.menu.links.expandMenu' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>{{ collapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
      <span>{{ collapsed ? ('app.menu.links.expandMenu' | translate) : ('app.menu.links.collapseMenu' | translate) }}</span>
    </a>

    <a mat-button class="navigation-link" (click)="logout()"
       [matTooltip]="collapsed ? ('app.menu.logoutButtonLabel' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>logout</mat-icon>
      <span>{{ 'app.menu.logoutButtonLabel' | translate }}</span>
    </a>
  </div>
</div>
